import styled from 'styled-components';
import { spacer16 } from '@spotify-internal/encore-web';
import {
  StyledIconExclamationActive,
  TypeWithLink,
  TypeWithMargin,
} from '@components/shared/styles';
import { formBodyHeight } from './constants';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: ${formBodyHeight};
`;

interface ErrorStateProps {
  title: string;
  text: string;
  textHasLink: boolean;
}

export const ErrorState = ({
  title,
  text,
  textHasLink = false,
}: ErrorStateProps) => {
  return (
    <Content>
      <StyledIconExclamationActive
        iconSize={32}
        data-cy="error-state"
        data-testid="exclamation-active-icon"
      />
      <TypeWithMargin
        variant="celloCanon"
        semanticColor="textBase"
        marginBottom={spacer16}
        marginTop={spacer16}
      >
        {title}
      </TypeWithMargin>
      {textHasLink ? (
        <TypeWithLink
          variant="viola"
          semanticColor="textBase"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      ) : (
        <TypeWithMargin variant="viola" semanticColor="textBase">
          {text}
        </TypeWithMargin>
      )}
    </Content>
  );
};
